import { serviceConstants } from '../_constants';

const initialState = {
  services: [],
  errors: {}
};


export function service(state = initialState, action) {
  switch (action.type) {

  case serviceConstants.SERVICE_OPTIONS_LOADED:
    return Object.assign({}, state, { options: action.data.actions.POST });

  case serviceConstants.SERVICES_LOADED:
    return Object.assign({}, state, { services: action.data });

  case serviceConstants.SERVICE_CREATED:
    let { services } = state;
    services.results.unshift(action.data);
    return Object.assign({}, state, { services, message: 'Service successfully created.' });

  case serviceConstants.SERVICE_LOADED:
    return Object.assign({}, state, { service: action.data});

  case serviceConstants.SERVICE_UPDATED:
    services = {...state.services };
    let idx = services.results.findIndex(item => item.id === action.data.id);
    services.results[idx] = action.data;
    return Object.assign({}, state, { services, message: 'Service successfully updated.' });

  case serviceConstants.SERVICE_ERRORS:
    return Object.assign({}, state, { errors: action.errors });

  case serviceConstants.SERVICE_DELETED:
    services = {...state.services };
    idx = services.results.findIndex(item => item.id === action.data.id);
    delete services[idx];
    return Object.assign({}, state, { services, message: 'Service successfully deleted.' });

  case serviceConstants.SERVICE_RESET:
    return Object.assign({}, state, { message: '', errors: {} });

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/service.reducer.js